


































































































import { breadcrumbApi } from '../breadcrumb.api';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component, Prop } from 'vue-property-decorator';
import { format } from 'date-fns';

@Component
export default class BreadcrumbsTable extends BaseTable {
  @Prop()
  public deviceId!: string;

  @Prop()
  public createdById!: string;

  public newBreadcrumbs = 0;
  public lastNewBreadcrumbsReset = new Date();
  public format = format;

  public buildFilters(gridFilters: any): void {
    this.$super(BaseTable).buildFilters(gridFilters);

    if (this.deviceId) {
      this.filters.deviceId = this.deviceId;
    }

    if (this.createdById) {
      this.filters.createdById = this.createdById;
    }
  }

  public async fetchData(): Promise<any> {
    return await breadcrumbApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  public get exportUrl(): string {
    return breadcrumbApi.getExportUrl();
  }
}
